// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2rgHL","expandedArea":"styles_expandedArea__1fPIx"};